import React, { useState } from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import Button from 'Mui/Button';
import ShareIcon from '@material-ui/icons/Share';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';

import DialogSystem from 'client/components/DialogSystem';

function NativeShare({ shareData }) {
    const [showError, setShowError] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function showErrorHint() {
        setShowError(true);
    }
    function closeErrorHint() {
        setShowError(false);
    }

    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    async function shareUrl(event) {
        try {
            await navigator.share(shareData).catch(err => {
                const { name } = err;
                if (name === 'NotAllowedError') {
                    showErrorHint();
                }
            });
        } catch (error) {
            handleClick(event);
        }
    }
    return (
        <>
            <Button variant="outlined" color="primary" css={buttonStyle} onClick={shareUrl}>
                <ShareIcon css={iconStyle} />
                {i18n.t('label.share_result')}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                css={css(`padding: 16px;`)}
            >
                <Typography css={css(`padding: 8px 16px;`)}>
                    {i18n.t('label.share_failed')}
                </Typography>
            </Popover>
            {showError && (
                <DialogSystem
                    title={i18n.t('label.shared_url_error')}
                    body={i18n.t('label.shared_or_not_auth')}
                    closePopup={closeErrorHint}
                />
            )}
        </>
    );
}

NativeShare.propTypes = {
    shareData: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string
    })
};

export default NativeShare;

const buttonStyle = css`
    border-radius: 28px;
    padding: 8px 16px;
    min-width: 120px;
`;

const iconStyle = css`
    padding-right: 2px;
`;
